import { SET_LANG, CLEAR_LANG } from "../actions/logActions";

const initLanguage = {
  value: null,
};

const langLogReducer = (state = initLanguage, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_LANG:
      return {
        ...state,
        value: payload,
      };
    case CLEAR_LANG:
      return { value: null };
    default:
      return state;
  }
};

export default langLogReducer;
